import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { formatNumber } from 'utils/formats';
import { useEquityMarketAdminPanel } from '../context/EquityMarketAdminPanelContext';

const EquityMarketAdminPanelSummaryCard: FC = () => {
  const { t } = useTranslate();

  const { data } = useEquityMarketAdminPanel();

  return (
    <div className="nk-block">
      <div className="row g-gs">
        <div className="col-sm-4">
          <div
            className="card card-bordered"
            style={{ borderLeft: '3px solid #1ee0ac' }}
          >
            <div className="card-inner py-3">
              <h6 className="overline-title text-soft mb-1">
                {t('SellOffers')}
              </h6>
              <h4 className="mb-1">
                {formatNumber(data.sellOffersCount)} {t('Offers').toLowerCase()}
              </h4>
              <p className="text-soft fs-13px mb-0">
                {formatNumber(data.statusCounts?.SELL?.ACTIVE ?? 0)}{' '}
                {t('Active')} ·{' '}
                {formatNumber(data.statusCounts?.SELL?.ACCEPTED ?? 0)}{' '}
                {t('Accepted')} ·{' '}
                {formatNumber(data.statusCounts?.SELL?.EXPIRED ?? 0)}{' '}
                {t('Expired')}
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-4">
          <div
            className="card card-bordered"
            style={{ borderLeft: '3px solid #6576ff' }}
          >
            <div className="card-inner py-3">
              <h6 className="overline-title text-soft mb-1">
                {t('BuyOffers')}
              </h6>
              <h4 className="mb-1">
                {formatNumber(data.buyOffersCount)} {t('Offers').toLowerCase()}
              </h4>
              <p className="text-soft fs-13px mb-0">
                {formatNumber(data.statusCounts?.BUY?.ACTIVE ?? 0)}{' '}
                {t('Active')} ·{' '}
                {formatNumber(data.statusCounts?.BUY?.ACCEPTED ?? 0)}{' '}
                {t('Accepted')} ·{' '}
                {formatNumber(data.statusCounts?.BUY?.EXPIRED ?? 0)}{' '}
                {t('Expired')}
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-4">
          <div
            className="card card-bordered"
            style={{ borderLeft: '3px solid #f4bd0e' }}
          >
            <div className="card-inner py-3">
              <h6 className="overline-title text-soft mb-1">
                {t('PendingOperations')}
              </h6>
              <h4 className="mb-1">{data.pendingOperationsCount}</h4>
              <p className="text-soft fs-13px mb-0">
                {t('PendingOperationsDescription')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquityMarketAdminPanelSummaryCard;
